
export const EDIT_CHANGELOG_CURRENT_LABEL = "Изменения текущей версии"

export const EDIT_CHANGELOG_LABEL = "Изменения версии"
